var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('symbol',{attrs:{"id":(_vm.prefix + "draft"),"viewBox":"0 0 16 16"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"7","fill":"none","stroke":_vm.getColor('main'),"stroke-width":"2","stroke-dasharray":"4.8 4.2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }